{
  "common": {
    "cancel": "Cancel",
    "delete": "Delete",
    "save": "Save"
  },
  "fieldTypes": {
    "text": "Short text",
    "textarea": "Long text",
    "select": "Single choice",
    "multiselect": "Multiple choice",
    "date": "Date",
    "number": "Number",
    "url": "URL",
    "boolean": "Yes/No"
  },
  "sections": {
    "personal": "Personal Information",
    "address": "Address",
    "social": "Social Media",
    "custom": "Additional Information"
  },
  "page": {
    "title": "Profile Fields",
    "subtitle": "Configure the fields members fill in on their profile",
    "hidePreview": "Hide",
    "showPreview": "Preview",
    "newField": "New Field",
    "deleteSuccess": "Field deleted",
    "deleteError": "Error deleting field",
    "toggleError": "Error updating field",
    "empty": {
      "title": "No custom fields",
      "description": "Create custom fields that members fill in on their profile",
      "create": "Create first field"
    },
    "deleteDialog": {
      "title": "Delete field",
      "description": "Are you sure you want to delete the field <bold>{{label}}</bold>? All values filled in by members will be lost."
    }
  },
  "preview": {
    "title": "Profile preview — how the member sees it",
    "fixed": "fixed",
    "custom": "custom",
    "selectPlaceholder": "Select",
    "personalDescription": "Fill in your main details",
    "fields": {
      "fullName": "Full name",
      "fullNamePlaceholder": "Your full name",
      "email": "Email",
      "emailPlaceholder": "email@example.com",
      "cpf": "CPF",
      "phone": "Mobile/WhatsApp",
      "birthDate": "Date of birth",
      "birthDatePlaceholder": "MM/DD/YYYY",
      "occupation": "Occupation",
      "occupationPlaceholder": "E.g. Full Stack Developer",
      "bio": "Bio",
      "bioPlaceholder": "Tell us a bit about yourself...",
      "zipCode": "ZIP code",
      "state": "State",
      "statePlaceholder": "NY",
      "city": "City",
      "cityPlaceholder": "New York",
      "neighborhood": "Neighborhood",
      "neighborhoodPlaceholder": "Neighborhood",
      "street": "Street",
      "streetPlaceholder": "Street, Avenue...",
      "number": "Number",
      "usernamePlaceholder": "@yourusername"
    }
  },
  "row": {
    "required": "required",
    "optionsCount_one": "{{count}} option",
    "optionsCount_zero": "{{count}} options",
    "optionsCount_other": "{{count}} options",
    "deactivate": "Deactivate",
    "activate": "Activate",
    "edit": "Edit",
    "delete": "Delete"
  },
  "dialog": {
    "labelRequired": "Field name is required",
    "updated": "Field updated",
    "created": "Field created",
    "saveError": "Error saving field",
    "editTitle": "Edit Field",
    "newTitle": "New Field",
    "label": "Field name *",
    "labelPlaceholder": "E.g. Professional experience",
    "type": "Type",
    "section": "Section",
    "options": "Options (comma-separated)",
    "optionsPlaceholder": "Option A, Option B, Option C",
    "placeholder": "Placeholder",
    "placeholderPlaceholder": "Hint text inside the field",
    "helpText": "Help text (optional)",
    "helpTextPlaceholder": "Description shown below the field",
    "required": "Required field",
    "create": "Create Field"
  }
}
